import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

// 一般及第三方匯入
import { FooterComponent } from './footer.component';
// ** translate
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [FooterComponent],
	imports: [BrowserModule, RouterModule, TranslateModule],
	exports: [FooterComponent],
})
export class FooterModule {}
